import { ChannelsContainer, IconsContainer } from "./StyledComponents";
import ChannelIcon, { Channel } from "./channel-icon/ChannelIcon";
import { useMemo } from "react";
import { sortChannels } from "./helper";
import { useTimeShiftedArray } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { ListTitle, ListTitleProps } from "@kaltura/mediaspace-shared-ui";

export interface ChannelsProps extends Omit<ListTitleProps, "analyticsActionText" | "analyticsType"> {
    channelsInLine: number;
    maxLinesNumber: number;
    timeShift: number;
    disableEntitlements: boolean;
    channels: Channel[];
    sortBy: string;
}

const Channels = (props: ChannelsProps) => {
    const {
        channelsInLine,
        maxLinesNumber,
        timeShift = 0,
        disableEntitlements,
        channels,
        sortBy,
        ...titleProps
    } = props;

    const totalItems = channelsInLine * maxLinesNumber;

    const sortedChannels = useMemo(() => sortChannels(channels, sortBy), [channels, sortBy]);
    const channelsToShow = useTimeShiftedArray(
        sortedChannels,
        // 1 minute = 60,000 milliseconds
        timeShift * 60000,
        totalItems
    );

    return (
        <ChannelsContainer>
            <ListTitle
                {...titleProps}
                analyticsActionText={"Channels collection component - See all"}
                analyticsType={ButtonClickAnalyticsType.LINK}
            />
            <IconsContainer>
                {channelsToShow.map((channel) => (
                    <ChannelIcon
                        channel={channel}
                        itemsInLine={channelsInLine}
                        disableEntitlements={disableEntitlements}
                    />
                ))}
            </IconsContainer>
        </ChannelsContainer>
    );
};

export default Channels;
